import React from 'react'
import { Box } from '@mantine/core'
import { Hero, Philosophy, Capabilities, AboutMe, Contact, Skills, Opensource } from 'src/modules'

export interface HomePageProps {}

export const HomePage: React.FC<HomePageProps> = () => {
  return (
    <Box>
      <Hero />
      <Philosophy />
      <Capabilities />
      <Skills />
      {/* <Portfolio /> */}
      <Opensource />
      <AboutMe />
      <Contact />
    </Box>
  )
}
